/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
import { useState, useEffect, useContext } from 'react';
import { StatusContext, StatusContextType } from './StatusContext';
import { getUsageStats } from '../data';
import { Table } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

 function UsageStats() {
    const statusContext = useContext(StatusContext);
    const [ stats, setStats ] = useState<any | null>(null);
    useEffect(() => {
        async function fetchStats() {
            try {
                const s = await getUsageStats();
                setStats(s);
            } catch (error : any) {
                statusContext.postError(`Error fetching usage stats: ${error.message}`);
                console.error('Error fetching stats:', error);
            }
        }
        fetchStats();
    }, []);

    if (!stats) {
        return <div>Loading...</div>;
    }   

    return (
        <Container>
            <Row>
                Total API Calls: {stats.request_count}
            </Row>
            <Row>
                <Table>
                    <thead>
                        <tr>
                            <th colSpan={2}>Tokens</th>
                            <th colSpan={2}>Costs</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Prompt</td>
                            <td>{stats.prompt_tokens}</td>
                            <td>Input</td>
                            <td>{stats.input_tokens_cost}</td>
                        </tr>
                        <tr>
                            <td>Completion</td>
                            <td>{stats.completion_tokens}</td>
                            <td>Output</td>
                            <td>{stats.output_tokens_cost}</td>
                        </tr>
                        <tr>
                            <td>Total</td>
                            <td>{stats.total_tokens}</td>
                            <td>Request</td>
                            <td>{stats.request_cost}</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>Total</td>
                            <td>{stats.total_cost}</td>
                        </tr>
                    </tbody>
                </Table>
            </Row>
        </Container>
    );
}

export default UsageStats;